/* eslint-disable prettier/prettier */
import { Button, IconButton, Menu, MenuItem, Select } from '@material-ui/core';
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import Chat from '../chat';

import ChatIcon from '@material-ui/icons/Chat';
import GroupIcon from '@material-ui/icons/Forum';
import ContactsIcon from '@material-ui/icons/Contacts';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import { NativeSelect } from '@material-ui/core';
import { Icon, InlineIcon } from '@iconify/react';
import squareEditOutline from '@iconify-icons/mdi/square-edit-outline';
import {
  Content,
  SidebarContainer,
  ChatMainContainer,
  Header,
  SearchArea,
  SearchInput,
  ConversationsContainer,
  ConversationItem,
  ContactContainer,
  ArchiveContainer,
  Status,
  StatusForSSE,
  Reads,
  DateTimeMessage,
  ButtonsContainer,
  ButtonsContainerMenu,
  ItensContainerMenu,
  HeaderChat,
  Profile,
  WelcomeContainer,
  WelcomeContent,
  ConnectionWarning,
  ConnectionWarningContent,
  ConnectionWarningIcon,
} from './styles';
import phoneImage from '../jitsi/molumen_phone_icon.png';
import { useConversation } from '../../hooks/conversation';
import { useAuth } from '../../hooks/auth';
import { useChatMessages } from '../../hooks/chat';
import ListContacts from '../../components/contacts';
import { useContacts } from '../../hooks/contacts';
import MenuSettings from '../../components/menuSettings';
import NewGroup from '../../components/newgroup';
import {
  convertBackendDate,
  getStringDate,
  truncateString,
  getPlainMessageText,
  getNotificationAvatar,
} from '../../utils';
import MenuConversation from '../../components/menuConversation';
import { useSignalRContext } from '../../contexts/SignalRContext';
import signalRService from '../../services/SignalRService';
import Info from '../../components/info';
import { useGroups } from '../../hooks/groups';
import { useHistory } from 'react-router-dom';
import { getPortalServerIp, getIdentificationId } from '../../storage';
import {
  getCallEvent,
  GetCallInformationUsingCallGuid,
  StartCallUsingContactInformation,
  GetOrCreateConversationByContactInformation,
  callDisconnectUsingGuid,
  callConnectUsingGuid,
} from '../../services/conversations';

import Groups from '../groups';
import ChangeLanguage from '../../components/ChangeLanguage';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import { useIntl, FormattedMessage } from 'react-intl';
import Swal from 'sweetalert2';
import colors from '../../styles/colors';
import ringer from './facebook_call.mp3';
import AccountSettings from '../../components/accountSettings';
import {
  REACT_APP_ENABLE_MAKECALL,
  REACT_APP_ENABLE_SERVERSENTEVENT,
  REACT_APP_VIEW_SSECONNECTIONSTATE,
} from '../../config';
import {
  FaUser,
  FaUsers,
  FaSignOutAlt,
  FaGlobe,
  FaArchive,
  FaPlusSquare,
  FaLock,
  FaPaperPlane,
  FaPhoneAlt,
  FaRegFileImage,
  FaLink,
  FaExclamationTriangle,
} from 'react-icons/fa';

const Conversations = () => {
  const { user, portal, setPortal, logout } = useAuth();

  const [anchorEl, setAnchorEl] = useState(null);
  const handleAccountClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleAccountClose = () => {
    setAnchorEl(null);
  };

  const [addAnchorEl, setAddanchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAddanchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAddanchorEl(null);
  };

  // prettier-ignore
  const {
    conversations,
    archiveds,
    filterName,
    setFilterName,
    openInfo,
    setOpenInfo,
    reloadArchivedConversations,
    hasCall,
    setHasCall,
    isSSEConnectionActive,
  } = useConversation();

  const {
    isConnected,
    joinConversation,
    leaveConversation,
    joinedConversationId,
    sendMessageUsingContactInformation_SignalR,
    sendMessageUsingFilter_SignalR,
    subscribeIncomingCall,
  } = useSignalRContext();

  const { reloadGroups, setMenuGroups, loadGroupsData, groups } = useGroups();
  const history = useHistory();
  const {
    conversation,
    setSelecetedConversation,
    setMessages,
    clearConversation,
    selectedPage,
    setSelectedPage,
    hasUpdate,
    setHasUpdate, //for SSE delete refresh
  } = useChatMessages();
  const [dataFiltered, setDataFiltered] = useState([]);
  const [archiveEffect, setArchiveEffect] = useState([]);
  const inputRef = useRef(null);
  const { setMenu } = useContacts();
  const intl = useIntl();
  const intlRef = useRef(intl);
  intlRef.current = intl;
  const [callEvents, setCallEvents] = React.useState(null);
  const [ringerTune, setRingerTune] = React.useState(null);
  const [isIncomingCall, setIsIncomingCall] = React.useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [hasFailed, setHasFailed] = useState(false);

  const lastIncomingCallGuidRef = useRef('');
  const callHandledRef = useRef(false);
  const audioRef = useRef(null);

  if (!audioRef.current) {
    audioRef.current = new Audio(ringer);
    audioRef.current.loop = true;
  }

  const stopRinger = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    setIsIncomingCall(false);
    setRingerTune(false);
  };

  const acceptCall = (callEvent) => {
    if (callHandledRef.current) return;
    callHandledRef.current = true;
    stopRinger();
    Swal.close();

    // notify backend that call was connected
    if (callEvent?.CallGuid) {
      callConnectUsingGuid(callEvent.CallGuid).catch(console.error);
    }

    history.push({
      pathname: '/jitsi/' + callEvent?.CallGuid,
      state: {
        callerData: {
          CallGuid: callEvent?.CallGuid,
          Name: callEvent?.ContactInformation?.Name,
        },
        callEvent,
      },
    });
  };

  const rejectCall = (callEvent) => {
    if (callHandledRef.current) return;
    callHandledRef.current = true;
    stopRinger();
    Swal.close();
    if (callEvent?.CallGuid) {
      callDisconnectUsingGuid(callEvent.CallGuid).catch(console.error);
    }
  };

  const handleCallEvent = async (data) => {
    // Completely disable receiving/handling incoming calls when flag is not true
    if (REACT_APP_ENABLE_MAKECALL !== 'true') {
      return;
    }

    // Do not show dialog if user is already in a call
    if (window.location.pathname.startsWith('/jitsi')) {
      return;
    }

    const callEvent = data?.callEvent || data;
    const callGuid = callEvent?.CallGuid;

    // check: Ignore call if initiated by self from another device
    const myIdentificationId = getIdentificationId();
    if (callEvent?.ContactInformation?.IdentityGuid === myIdentificationId) {
      return;
    }

    // Deduplication check: ignore if already handled or ringing
    if (!callGuid || lastIncomingCallGuidRef.current === callGuid) {
      return;
    }
    lastIncomingCallGuidRef.current = callGuid;
    callHandledRef.current = false;

    setIsIncomingCall(true);
    setRingerTune(true);
    setCallEvents(callEvent);

    // Play ringer
    if (audioRef.current) {
      audioRef.current.loop = true;
      audioRef.current.play().catch((err) => {
        console.warn('[Call] Autoplay waiting for user interaction:', err);
      });
    }

    const callerName = callEvent?.ContactInformation?.Name || 'Incoming Call';

    // Dynamic photo URL from IdentityGuid or ProfilePhoto
    const portalIp = getPortalServerIp();
    const identityGuid = callEvent?.ContactInformation?.IdentityGuid;
    const photoUrl = callEvent?.ContactInformation?.ProfilePhoto || null;

    // Localized texts with name bound in code (uses active language)
    const currentIntl = intlRef.current || intl;
    const callTitle = `${currentIntl.formatMessage({
      id: 'callFrom',
      defaultMessage: 'Call from',
    })} ${callerName}`;
    const callPrompt = currentIntl.formatMessage({
      id: 'doYouWantToAcceptCall',
      defaultMessage: 'Do you want to accept the call?',
    });
    const yesText = currentIntl.formatMessage({
      id: 'Yes',
      defaultMessage: 'Yes',
    });
    const noText = currentIntl.formatMessage({
      id: 'No',
      defaultMessage: 'No',
    });

    // Browser notification
    if ('Notification' in window && Notification.permission === 'granted') {
      const avatarIcon = await getNotificationAvatar(callerName, photoUrl);
      const notification = new Notification(callTitle, {
        body: callPrompt,
        icon: avatarIcon,
      });
      notification.onclick = () => {
        window.focus();
        notification.close();
        acceptCall(callEvent);
      };
    }

    // Confirmation dialog
    Swal.fire({
      title: callTitle,
      text: callPrompt,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: colors?.primary || '#264D6B',
      cancelButtonColor: colors?.error || '#d33',
      confirmButtonText: yesText,
      cancelButtonText: noText,
      allowOutsideClick: false,
    }).then((result) => {
      if (result.value) {
        acceptCall(callEvent);
      } else {
        rejectCall(callEvent);
      }
    });
  };

  const handleCallEventRef = useRef(handleCallEvent);
  handleCallEventRef.current = handleCallEvent;

  // 1. SignalR Real-Time Incoming Call Listener (Desktop Style)
  useEffect(() => {
    if (REACT_APP_ENABLE_MAKECALL !== 'true') return;
    if (!subscribeIncomingCall) return;

    const unsubscribe = subscribeIncomingCall((data) => {
      // check: Ignore call if initiated by self from another device
      const myIdentificationId = getIdentificationId();
      if (data?.ContactInformation?.IdentityGuid === myIdentificationId) {
        return;
      }

      if (handleCallEventRef.current) {
        handleCallEventRef.current(data);
      }
    });

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [subscribeIncomingCall]);

  // 2. HTTP API fallback helper (Desktop pattern: disabled when SignalR is connected)
  const getCallEventFromAPI = async () => {
    if (REACT_APP_ENABLE_MAKECALL !== 'true') return;
    // When SignalR is connected, real-time events handle calls — never call HTTP API
    if (signalRService?.isConnected || isConnected) return;

    try {
      const data = await getCallEvent();
      if (data?.GetCallEventResult === true && data?.callEvent) {
        handleCallEvent(data.callEvent);
      }
    } catch (error) {
      console.error('Error fetching call event from API:', error);
    }
  };

  // 3. SSE Fallback (ONLY runs when SignalR is NOT connected)
  useEffect(() => {
    if (REACT_APP_ENABLE_MAKECALL !== 'true') return;
    // When SignalR is connected, DO NOT trigger the SSE / HTTP fallback
    if (signalRService?.isConnected || isConnected) return;

    if (REACT_APP_ENABLE_SERVERSENTEVENT === 'true') {
      if (user && portal && !isIncomingCall && hasCall) {
        getCallEventFromAPI();
      }
    }
  }, [user, portal, hasCall, isIncomingCall, isConnected]);

  // 4. Cleanup audio & dialog on unmount
  useEffect(() => {
    return () => {
      stopRinger();
      Swal.close();
    };
  }, []);

  // end check if any incoming call
  useEffect(() => {
    if (REACT_APP_ENABLE_SERVERSENTEVENT === 'false') {
      if (conversations) {
        setDataFiltered(
          conversations.filter((c) =>
            c.Owner.Name.toUpperCase().includes(filterName.toUpperCase())
          )
        );
        setSelectedPage(true);
      }
    }
  }, [conversations]);

  //This useeffect is same as above has only change of filterName added in its parameter for SSE
  useEffect(() => {
    if (REACT_APP_ENABLE_SERVERSENTEVENT === 'true') {
      if (conversations) {
        setDataFiltered(
          conversations.filter((c) =>
            c.Owner.Name.toUpperCase().includes(filterName.toUpperCase())
          )
        );
        setSelectedPage(true);
      }
    }
  }, [conversations, filterName]);

  const ensureGroupsInConversations = (groups = [], allConversations = []) => {
    const updatedConvos = [...allConversations];

    groups.forEach((group) => {
      const exists = updatedConvos.some(
        (conv) => conv?.Owner?.StaffGuid === group.GroupGuid
      );

      if (!exists) {
        updatedConvos.push({
          Administrator: group.Administrator,
          Broadcast: group.Broadcast,
          Guid: group.GroupGuid,
          Priority: group.Priority,
          IsGroupConversation: true,
          isGroup: true,
          isTemporaryGroup: true,
          Name: group.Name,
          Owner: {
            Name: group.Name,
            Number: group.GroupGuid,
            StaffGuid: group.GroupGuid,
          },

          LastMessage: null,
          NumberOfUnreadMessages: 0,
        });
      }
    });

    return updatedConvos;
  };

  useEffect(() => {
    if (!conversations) return;

    const merged = ensureGroupsInConversations(
      groups || [],
      conversations || []
    );

    setDataFiltered(
      merged.filter((c) =>
        c?.Owner?.Name?.toUpperCase().includes(filterName.toUpperCase())
      )
    );

    setSelectedPage(true);
  }, [groups, conversations, filterName]);

  useEffect(() => {
    if (conversations) {
      // console.log(conversations)

      setArchiveEffect(archiveds);
      setSelectedPage(true);
      if (REACT_APP_ENABLE_SERVERSENTEVENT === 'true') {
        // TODO: need to remove
        // setHasUpdate(hasUpdate == 0 ? 1 : 0);
      }
    }
  }, [conversations]);

  const onKeyUp = (event) => {
    setFilterName(inputRef.current?.value);
  };

  const handleClickContacts = (event) => {
    clearConversation('');
    setSelectedPage(false);
    if (openInfo) setOpenInfo(false);
    history.push('/contacts');
    if (REACT_APP_ENABLE_SERVERSENTEVENT === 'true') {
      loadGroupsData(true);
    }
  };

  const handleClickArchived = (event) => {
    clearConversation('');
    setSelectedPage(false);
    setOpenInfo(false);
    history.push('/archiveds');
  };

  const handleClickMessages = (event) => {
    history.push('/app');
  };

  const handleSelectTempGroupContact = async (groupItem) => {
    try {
      const response = await GetOrCreateConversationByContactInformation({
        contactInformation: {
          Name: groupItem.Name,
          Priority: groupItem.Priority,
          StaffGuid: groupItem.Guid,
        },
      });

      setSelecetedConversation({
        ...response.conversation,
        isGroup: response.IsGroupConversation,
      });
    } catch (error) {
      console.error('Error creating temp group conversation:', error);
    }
  };

  const getMessagePreview = (lastMessage, deletedText) => {
    const lm = lastMessage;
    let titleText;
    let previewText;

    if (lm.IsForward === true) {
      titleText = 'Forwarded message';
      previewText =
        lm.Message === deletedText ? deletedText : 'Forwarded message';
    } else if (lm.IsPoll) {
      titleText = 'Poll Message';
      previewText = 'Poll Message';
    } else if (
      lm.Attachments?.length > 0 &&
      (!lm.Message || lm.Message.trim() === '')
    ) {
      titleText = 'sent a file';
      previewText = 'sent a file';
    } else {
      const rawText = lm.Message || '';
      // Strip HTML tags if IsHtmlMessage is true OR if raw string contains any HTML tags
      const cleanText =
        lm.IsHtmlMessage || /<[a-z][\s\S]*>/i.test(rawText)
          ? getPlainMessageText(rawText)
          : rawText;

      titleText = cleanText;
      previewText = cleanText;
    }
    return { titleText, previewText };
  };

  // (Prevents false positives from Windows Hyper-V virtual network adapters)
  const checkServerReachability = async () => {
    if (!navigator.onLine) return false;

    try {
      const portalIp = getPortalServerIp();
      if (
        !portalIp ||
        portalIp === 'https://null' ||
        portalIp.includes('undefined')
      ) {
        return false;
      }

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 2500);

      // Probe our own server.
      // If Ethernet is disabled, this fails with net::ERR_NAME_NOT_RESOLVED (rejection).
      // If network is alive, fetch successfully communicates with our server.
      await fetch(`${portalIp}/favicon.ico?_=${Date.now()}`, {
        mode: 'no-cors',
        cache: 'no-store',
        signal: controller.signal,
      });

      clearTimeout(timeoutId);
      return true;
    } catch (err) {
      // TypeError: Failed to fetch -> network is truly down/unreachable
      return false;
    }
  };

  useEffect(() => {
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);

    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  // Actively verify server reachability when SignalR disconnects
  useEffect(() => {
    let isMounted = true;
    let intervalId = null;

    const verifyNetwork = async () => {
      const reachable = await checkServerReachability();
      if (isMounted) {
        setIsOnline(reachable);
      }
    };

    if (!isConnected && hasFailed) {
      // Immediately test our server reachability
      verifyNetwork();
      // Poll every 5 seconds while disconnected
      intervalId = setInterval(verifyNetwork, 5000);
    } else if (isConnected) {
      // When connected, server and internet are confirmed active
      setIsOnline(true);
      setHasFailed(false);
    }

    return () => {
      isMounted = false;
      if (intervalId) clearInterval(intervalId);
    };
  }, [isConnected, hasFailed]);

  useEffect(() => {
    const handleFail = () => {
      setHasFailed(true);
      checkServerReachability().then((reachable) => setIsOnline(reachable));
    };
    window.addEventListener('signalr-failed', handleFail);
    return () => window.removeEventListener('signalr-failed', handleFail);
  }, []);

  return (
    <>
      {(!isOnline || (!isConnected && hasFailed)) && (
        <ConnectionWarning>
          <ConnectionWarningContent>
            <ConnectionWarningIcon>
              <FaExclamationTriangle size={16} />
            </ConnectionWarningIcon>
            <span>
              {!isOnline
                ? intl.formatMessage({
                    id: 'noInternetConnection',
                    defaultMessage:
                      'No internet connection. Please check your network. The app will attempt to reconnect automatically.',
                  })
                : intl.formatMessage({
                    id: 'chatServerReconnecting',
                    defaultMessage:
                      'Connecting to chat service... The app will attempt to reconnect automatically.',
                  })}
            </span>
          </ConnectionWarningContent>
        </ConnectionWarning>
      )}

      <Content>
        {/* ================= LEFT SIDE: CONVERSATION LIST ================= */}
        <SidebarContainer>
          <Header>
            <ButtonsContainerMenu>
              <ItensContainerMenu
                title={intl.formatMessage({ id: 'Messages' })}
                isSelected={selectedPage}
              >
                <ChatIcon onClick={handleClickMessages} />
              </ItensContainerMenu>
              <ItensContainerMenu title={intl.formatMessage({ id: 'Logout' })}>
                <FaSignOutAlt
                  size={22}
                  onClick={() => {
                    clearConversation('');
                    logout();
                  }}
                />
              </ItensContainerMenu>
            </ButtonsContainerMenu>

            {intl.formatMessage({ id: 'Messages' })}

            <ButtonsContainerMenu>
              <ItensContainerMenu
                title={intl.formatMessage({ id: 'NewMessage' })}
              >
                <Icon
                  icon={squareEditOutline}
                  width="24px"
                  height="24px"
                  onClick={async () => {
                    if (REACT_APP_ENABLE_SERVERSENTEVENT === 'false') {
                      await reloadGroups();
                    }
                    setMenu(true);
                  }}
                />
              </ItensContainerMenu>
              <ItensContainerMenu
                title={intl.formatMessage({ id: 'NewChartGroup' })}
              >
                <GroupIcon
                  onClick={async () => {
                    setMenuGroups(true);
                  }}
                />
              </ItensContainerMenu>
              <ItensContainerMenu title={intl.formatMessage({ id: 'Idioms' })}>
                <ChangeLanguage space="0rem" />
              </ItensContainerMenu>
              {REACT_APP_VIEW_SSECONNECTIONSTATE === 'true' && (
                <Profile>
                  {isSSEConnectionActive ? (
                    <StatusForSSE status={1} />
                  ) : (
                    <StatusForSSE status={2} />
                  )}
                </Profile>
              )}
              <ItensContainerMenu title={intl.formatMessage({ id: 'Account' })}>
                <AccountCircleOutlinedIcon onClick={handleAccountClick} />
                <AccountSettings
                  anchorEl={anchorEl}
                  handleClose={handleAccountClose}
                />
              </ItensContainerMenu>
            </ButtonsContainerMenu>
          </Header>

          <SearchArea>
            <SearchInput
              ref={inputRef}
              onKeyUp={onKeyUp}
              placeholder={intl.formatMessage({ id: 'SearchHere' })}
            />
            <FaPlusSquare color="#666666" onClick={handleClick} />
            <Menu
              id="simple-menu"
              anchorEl={addAnchorEl}
              keepMounted
              open={Boolean(addAnchorEl)}
              onClose={handleClose}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              PaperProps={{
                style: {
                  marginTop: '8px',
                },
              }}
            >
              <MenuItem
                onClick={async () => {
                  if (REACT_APP_ENABLE_SERVERSENTEVENT === 'false') {
                    await reloadGroups();
                  }
                  setMenu(true);
                  handleClose();
                }}
              >
                {intl.formatMessage({ id: 'NewChat' })}
              </MenuItem>
              <MenuItem
                onClick={async () => {
                  setMenuGroups(true);
                  handleClose();
                }}
              >
                {intl.formatMessage({ id: 'NewGroup' })}
              </MenuItem>
            </Menu>
          </SearchArea>

          <ConversationsContainer>
            {archiveEffect && archiveEffect.length > 0 && (
              <ConversationItem onClick={handleClickArchived}>
                <ArchiveContainer>
                  <div style={{ display: 'flex', columnGap: 5 }}>
                    <FaArchive />
                    <span title={intl.formatMessage({ id: 'Archiveds' })}>
                      {truncateString(
                        intl.formatMessage({ id: 'Archiveds' }),
                        60
                      )}
                    </span>
                  </div>
                </ArchiveContainer>
              </ConversationItem>
            )}
            {dataFiltered &&
              dataFiltered.length > 0 &&
              dataFiltered.map((c, key) => {
                let dateString = '';
                if (c.LastMessage) {
                  dateString = convertBackendDate(
                    c.LastMessage.MessageDateTime
                  );
                }

                const deletedText = intl.formatMessage({
                  id: 'ThisMessageHasBeenDeleted',
                });
                const { titleText, previewText } = c.LastMessage
                  ? getMessagePreview(c.LastMessage, deletedText)
                  : {};

                return (
                  <ConversationItem
                    key={key}
                    onClick={() => {
                      if (c.isTemporaryGroup) {
                        handleSelectTempGroupContact(c);
                      } else {
                        setSelecetedConversation({ ...c });
                        setMessages([]);
                      }
                    }}
                    isSelected={conversation && conversation.Guid === c.Guid}
                  >
                    {c.NumberOfUnreadMessages !== 0 && (
                      <Reads>{c.NumberOfUnreadMessages}</Reads>
                    )}
                    <ContactContainer>
                      <div style={{ display: 'flex', columnGap: 5 }}>
                        {!c.isGroup && <FaUser />}
                        {c.isGroup && <FaUsers />}
                        <span title={c.Owner.Name}>
                          {truncateString(c.Owner.Name, 60)}
                        </span>
                      </div>
                      {!c.isGroup && c.LastMessage && (
                        <h6 title={titleText}>
                          {truncateString(previewText, 60)}
                        </h6>
                      )}

                      {c.isGroup && c.LastMessage && (
                        <h6 title={titleText}>
                          {truncateString(
                            `${c.LastMessage.Sender.Name}: ${previewText}`,
                            60
                          )}
                        </h6>
                      )}
                    </ContactContainer>
                    <DateTimeMessage
                      unreadLabel={c.NumberOfUnreadMessages !== 0}
                    >
                      {getStringDate(dateString)}
                    </DateTimeMessage>
                  </ConversationItem>
                );
              })}
          </ConversationsContainer>
        </SidebarContainer>

        {/* ================= RIGHT SIDE: HEADER & CHAT ================= */}
        <ChatMainContainer>
          {conversation ? (
            <React.Fragment>
              <HeaderChat>
                <div>
                  <Profile>
                    {!conversation.isGroup && !conversation.Owner.Name && (
                      <Status status={conversation.Owner.OnlineState} />
                    )}
                    {conversation.Owner?.Name}
                  </Profile>
                </div>
                <MenuConversation />
              </HeaderChat>
              <Chat conversationId={conversation} />
            </React.Fragment>
          ) : (
            <WelcomeContainer>
              <WelcomeContent>
                <FaUsers size={60} />
                <h3>
                  <FormattedMessage
                    id="connectAndChat"
                    defaultMessage="Connect and chat with colleagues, friends and family."
                  />
                </h3>
                <div>
                  <p>
                    <FaPaperPlane size={15} />{' '}
                    <FormattedMessage
                      id="sendMessagesInstantly"
                      defaultMessage="Send messages instantly"
                    />
                  </p>
                  <p>
                    <FaPhoneAlt size={15} />{' '}
                    <FormattedMessage
                      id="makeVoiceAndVideoCalls"
                      defaultMessage="Make voice and video calls"
                    />
                  </p>
                  <p>
                    <FaRegFileImage size={15} />{' '}
                    <FormattedMessage
                      id="sharePhotosAndFiles"
                      defaultMessage="Share photos and files"
                    />
                  </p>
                  <p>
                    <FaUsers size={15} />{' '}
                    <FormattedMessage
                      id="createGroupChats"
                      defaultMessage="Create group chats"
                    />
                  </p>
                  <p>
                    <FaLink size={15} />{' '}
                    <FormattedMessage
                      id="stayConnected"
                      defaultMessage="Stay connected"
                    />
                  </p>
                </div>
              </WelcomeContent>
            </WelcomeContainer>
          )}
        </ChatMainContainer>

        <Info />
        <ListContacts clearFilterChats={() => setFilterName('')} />
        <NewGroup clearFilterChats={() => setFilterName('')} />
      </Content>
    </>
  );
};

export default Conversations;
